// extracted by mini-css-extract-plugin
export var gridContainer = "homepage-video-module--grid-container--4ef22";
export var image = "homepage-video-module--image--770e8";
export var offsetCards = "homepage-video-module--offset-cards--defdb";
export var shape1 = "homepage-video-module--shape1--8be5e";
export var shape2 = "homepage-video-module--shape2--55a0f";
export var shape3 = "homepage-video-module--shape3--df090";
export var shape4 = "homepage-video-module--shape4--97f04";
export var shape5 = "homepage-video-module--shape5--3a5a5";
export var shape6 = "homepage-video-module--shape6--3427f";
export var shape7 = "homepage-video-module--shape7--b4b14";
export var shape8 = "homepage-video-module--shape8--42279";
export var videoContainer = "homepage-video-module--video-container--4b7c7";
export var videoText = "homepage-video-module--video-text--f3bf2";